import { useState } from "react";
import { apiPost } from "../api";
import { toastError, toastSuccess } from "../utils/toast";
import "./css/contact.css";

export default function ContactBody() {
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const trimmed = {
      name: values.name.trim(),
      email: values.email.trim(),
      phone: values.phone.trim(),
      message: values.message.trim(),
    };

    if (!trimmed.name || trimmed.name.length < 2) {
      toastError("Please enter your name (at least 2 characters).");
      return;
    }
    if (!trimmed.email || !/\S+@\S+\.\S+/.test(trimmed.email)) {
      toastError("Please enter a valid email.");
      return;
    }
    const digitCount = trimmed.phone.replace(/\D/g, "").length;
    if (!trimmed.phone || digitCount < 7) {
      toastError("Please enter a valid phone number (at least 7 digits).");
      return;
    }
    if (!trimmed.message || trimmed.message.length < 5) {
      toastError("Please enter your message (at least 5 characters).");
      return;
    }

    const payload = {
      name: trimmed.name,
      email: trimmed.email,
      phone: trimmed.phone,
      message: trimmed.message,
    };

    try {
      setLoading(true);
      await apiPost("user-queries/create", payload);
      toastSuccess("Thanks! Your message has been sent.");
      setValues({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (err) {
      const firstError =
        typeof err?.response?.data === "object"
          ? Object.values(err.response.data)[0]
          : err?.message || "Failed to send message";
      toastError(firstError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-body">
      <div className="cl-container contact-wrap">
        <div className="contact-header">
          <p className="cl-eyebrow center">Contact</p>
          <h1 className="contact-heading">We Are Here to Help</h1>
          <p className="contact-subtext">
            Get in touch or book a free consultation.
          </p>
        </div>

        <div className="contact-layout">
          <aside className="contact-info" aria-label="Contact details">
            <article className="contact-info-card">
              <span className="contact-info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z" />
                  <circle cx="12" cy="10" r="2.5" />
                </svg>
              </span>
              <div>
                <h2>Address</h2>
                <p>Burjuman Business Tower, Dubai, United Arab Emirates</p>
              </div>
            </article>

            <a className="contact-info-card" href="tel:+971585900697">
              <span className="contact-info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.09 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.6 2.6a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.48-1.17a2 2 0 0 1 2.11-.45c.83.28 1.7.48 2.6.6A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <div>
                <h2>Phone</h2>
                <p>+971 58 590 0697</p>
              </div>
            </a>

            <a className="contact-info-card" href="mailto:info@clicklaw.ae">
              <span className="contact-info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
              </span>
              <div>
                <h2>Email</h2>
                <p>info@clicklaw.ae</p>
              </div>
            </a>
          </aside>

          <section className="contact-section">
        <form className="contact-form" onSubmit={onSubmit} noValidate>
          <div className="form-row">
            <label className="contact-label">
              <span className="req">*</span> Name
              <input
                type="text"
                name="name"
                className="contact-input"
                placeholder="Your full name"
                value={values.name}
                onChange={onChange}
                required
              />
            </label>

            <label className="contact-label">
              <span className="req">*</span> Email
              <input
                type="email"
                name="email"
                className="contact-input"
                placeholder="you@example.com"
                value={values.email}
                onChange={onChange}
                required
              />
            </label>
          </div>

          <label className="contact-label">
            <span className="req">*</span> Phone
            <input
              type="tel"
              name="phone"
              className="contact-input"
              placeholder="+971 50 123 4567"
              value={values.phone}
              onChange={onChange}
              required
            />
          </label>

          <label className="contact-label">
            <span className="req">*</span> Message
            <textarea
              name="message"
              className="contact-input contact-textarea"
              placeholder="Write your message here…"
              rows={6}
              value={values.message}
              onChange={onChange}
              required
            />
          </label>

          <button className="contact-btn" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>
                Sending…
              </>
            ) : (
              "Send Message"
            )}
          </button>
        </form>
          </section>
        </div>
      </div>

      <hr className="contact-divider" aria-hidden="true" />

      <section className="map-section">
        <div className="map-header">
          <h2 className="map-title">Visit Our Location</h2>
          <p className="map-subtext">
            We're located at Burjuman Business Tower in Dubai. Feel free to drop by our office.
          </p>
        </div>

        <div className="map-container">
          <iframe
            src="https://maps.google.com/maps?q=Burjuman%20Business%20Tower%2C%20Dubai%2C%20United%20Arab%20Emirates&hl=en&z=17&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps - Burjuman Business Tower, Dubai"
          ></iframe>
        </div>
      </section>
    </section>
  );
}
